import { RESET_STATE, UPDATE_MESSAGE, ACTION_LOGOUT_INITIATED } from '../actions/types';

const initialState = {
	type: '',
	message: false,
	text: null,
};

export default function (state = initialState, action) {
	switch (action.type) {
		case RESET_STATE:
			return initialState;

		case UPDATE_MESSAGE:
			return {
				...state,
				message: Boolean(action.payload.flag),
				type: action.payload.type,
				text: action.payload.text == null ? null : action.payload.text,
			};
			
		case ACTION_LOGOUT_INITIATED:
			return initialState;	
		
		default:
			return state;
	}
}
